<svelte:head>
        <script src="https://sdk.twilio.com/js/client/v1.13/twilio.min.js"></script>
</svelte:head>

<!-- https://www.twilio.com/docs/voice/sdks/javascript/overview-1x-deprecated/device -->

<script>
  import {fly} from "svelte/transition"
  import Forum from "svelte-material-icons/Forum.svelte";
  import Phone from "svelte-material-icons/Phone.svelte";
  import WindowMinimize from "svelte-material-icons/WindowMinimize.svelte";
  import Click2Call from "./Click2Call.svelte";

  export let open;
  let mode = "chat"

  let name = 'A guest';
  let intervalId;

  $: open, mode, setTimeout(() => {
    if(open && mode=="chat") load_chat_widget()

  }, 100);

  const successHandler = (chatSession) => {
      // console.log(chatSession)
      // console.info("successHandler");
      chatSession.incomingItemDecorator = function (item) {
          // console.log(item)
          if(item.displayName == "SYSTEM_MESSAGE"){
            item.displayName = "System Message"
          }
          if(item.displayName == "BOT"){
            item.displayName = "Magellan Bot"
          }
          return item;
      }
      chatSession.onIncoming(function (data) {
          // console.log("incoming message:|| " + JSON.stringify(data));
      });

      chatSession.onOutgoing(function (data) {
          // console.log("outgoing message:|| " + JSON.stringify(data));
      });

      chatSession.onChatDisconnected(function (data) {
          // console.info("Chat has been disconnected");
          // console.log(data);
          // mode="chat-form"
          // start_chat()

      });
  };

  const failureHandler = (e) => {
      // chat failed
      console.error("failed", e);
      mode="chat"
  };

  const load_chat_widget =()=>{
    // console.log(1)
    window.connect.ChatInterface.init({
        containerId: 'chat-widget', // This is the id of the container where you want the widget to reside
        headerConfig:{
          isHTML: true,
          render:()=>{
            return(``)
          }
        },
        footerConfig:{
          isHTML: true,
          render:()=>{
            return(``)
          }
        }
    });

    // window.connect

    let params = {
      name,
      region: "us-east-1",
      apiGatewayEndpoint: "https://e0pbi5igwa.execute-api.us-east-1.amazonaws.com/Prod",
      // contactAttributes: JSON.stringify({customerName:name, cutomerEmail:email}),
      contactFlowId:"56738b60-892e-4cef-8375-d87dc4e04860", //To change the contact flow I think we have to change a bunch of lambdas that were auto deployed. Maybe just redeploy?
      instanceId: '485ed4eb-7aa0-4fb7-8446-df62c0df7401',
      featurePermissions: {
          "ATTACHMENTS": true
      }
    }
    window.connect.ChatInterface.initiateChat(params, successHandler, failureHandler);
  }

  const url = "https://us-central1-ccaas-untangl.cloudfunctions.net/twilio"

  // const url = "http://localhost:8000/token"
  let DEVICE; //twilio device
  


  let call_status = "calling..."
  

  const start_chat=()=>{
    mode = "chat"
    call_status="call ended"
    clearInterval(intervalId);
  }


  const close = () => {
    clearInterval(intervalId);
    open=false
	}

  const start_call=()=>{
    mode = "phone"
  }

</script>


{#if open}
  <div in:fly={{x:300, y:500, duration:400}} out:fly={{x:300, y:500, duration:1000}} style="height:600px" class="fixed bottom-3 right-3 max-w-sm flex flex-col bg-gray-200 rounded-lg" >
    <!-- Header -->
    <div class="flex items-center justify-between bg-slate-900 rounded-t-lg p-4">
      <div>
        <img src="img/magellan-white.png" alt="magellan"/>
      </div>
      <div class="flex items-center justify-center text-lg ml-12">
        <div class={`ml-6 cursor-pointer`} on:click={start_chat}>
          <Forum color={mode.includes("chat")?'#0284c7':"white"} size={"24px"}/>
        </div>
        <div class={`ml-6 cursor-pointer`} on:click={start_call}>
          <Phone color={mode.includes("phone")?'#0284c7':"white"} size={"24px"}/>
        </div>
        <div class={`ml-6 cursor-pointer`} on:click={close}>
          <WindowMinimize color="white" size={"24px"}/>
        </div>
      </div>
    </div>
    <!--  Body -->
    <div class="flex flex-col p-2 rounded-b-lg h-full">
      <!-- Modes -->
      {#if mode == "chat"}
        <div id="chat-widget"/>
        <button on:click={close} class="text-white bg-red-700 px-4 py-2 mb-2 rounded-md w-1/2 m-auto">End Chat</button>
      {:else if mode=="phone"}
        <Click2Call bind:call_status={call_status} bind:intervalId={intervalId} bind:mode={mode}/>
      {/if}
    </div>
  </div>
{/if}


